module.exports = __webpack_public_path__ + "static/Q8Answer5_BadGuy_RossSokolovski-f1a7425aec08afc4f61f9803b031a43a.jpg";